/*
 * Copyright (c) 2023 Roboto Technologies, Inc.
 */
import { Box, Divider, useTheme } from "@mui/material";
import * as React from "react";
import { useSearchParams } from "react-router-dom";

import { useAuth } from "@/providers";
import { NavigationPage, PageHeader } from "@/shared/components";
import {
  RobotoStyledTab,
  RobotoStyledTabs,
  RobotoTabPanel,
} from "@/shared/components/RobotoStyledTabs";
import { UserProfile } from "@/shared/components/user";

import { Preferences } from "./Preferences";
import { Tokens } from "./Tokens";

export const Account: React.FC = () => {
  const [searchParams, setSearchParams] = useSearchParams();

  const tabSearchParam = searchParams.get("tab");
  const tabValue = tabSearchParam !== null ? parseInt(tabSearchParam) : 0;

  const theme = useTheme();
  const { currentUser } = useAuth();

  return (
    <NavigationPage title={"Roboto - Account"}>
      <PageHeader>Account</PageHeader>

      <Box
        sx={{
          paddingTop: theme.spacing(3),
          paddingBottom: theme.spacing(2),
        }}
      >
        <RobotoStyledTabs
          value={tabValue}
          onChange={(_event, newValue) => {
            setSearchParams({ tab: String(newValue) });
          }}
        >
          <RobotoStyledTab label="Profile" />
          <RobotoStyledTab label="Tokens" />
          <RobotoStyledTab label="Preferences" />
        </RobotoStyledTabs>

        <Divider
          sx={{
            borderColor: theme.border.color,
          }}
        />
      </Box>

      <Box>
        <RobotoTabPanel index={0} value={tabValue}>
          <UserProfile user={currentUser} />
        </RobotoTabPanel>

        <RobotoTabPanel index={1} value={tabValue}>
          <Tokens />
        </RobotoTabPanel>

        <RobotoTabPanel index={2} value={tabValue}>
          <Preferences />
        </RobotoTabPanel>
      </Box>
    </NavigationPage>
  );
};
